module.exports = __webpack_public_path__ + "media/images/image_gap-234013ba4d07a62173eaf5debf64bd8f.jpg";